import { styled } from "@mui/material"

export const StyledLoginForm = styled("form")({
	display: "grid",

	"& .MuiFormControl-root": {
		height: "6.4rem",
	},

	"& .MuiFormControl-root:last-of-type": {
		height: "7.683rem"
	},
})
